import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DeleteIcon from "@material-ui/icons/Delete";
import { colors, IconButton, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Print from "@material-ui/icons/Print";
import {
    useStylesAutoPurch
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesLbl,
    useStylesAutoSafe,
    useStylesTF,
    useStylesAuto,
} from '../../../../St/Reports/UseStyle';
import { Autocomplete } from "@material-ui/lab";
const useStyles = makeStyles((theme) => ({
    table: {
        minHeight: 75,
    },
}));

export default function SubUnitsTables(props) {
    const { currUnitList, setCurrUnitList, items, units, confirmDialog,
        setConfirmDialog, openPrint } = props;
    const handleFocus = (e) => e.target.select();
    const [rowItem, setRowItem] = useState({});


    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasSaf = useStylesAutoSafe();
    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 12,
        color: "#000"
    }
    const handleOpenUpdate = (props, e, row) => {
        var newDataUnit = currUnitList.filter((obj) => obj.editUnit === true);
        var newDataPerc = currUnitList.filter((obj) => obj?.editPerc === true);
        var newDataPurch = currUnitList.filter((obj) => obj.editPurch === true);
        var newDataSalse = currUnitList.filter((obj) => obj.editSale === true);
        var newDatabarcode = currUnitList.filter((obj) => obj.editBarcode === true);

        if (rowItem?.no != null) {
            if (newDataUnit.length != 0 && props !== "editUnit") {
                EnterChangeTtems("unit", rowItem, row);
                setRowItem({});
            }
            else if (newDataPerc.length != 0 && props !== "editPerc") {
                EnterChangeTtems("perc", rowItem, row);
            }
            else if (newDataPurch.length != 0 && props !== "editPurch") {
                EnterChangeTtems("purch", rowItem, row);
            } else if (newDataSalse.length != 0 && props !== "editSale") {
                EnterChangeTtems("sale", rowItem, row);
            } else if (newDatabarcode.length != 0 && props !== "editBarcode") {
                EnterChangeTtems("barcode", rowItem, row);
            }
        } else {
            if (props === "editUnit") {

                e.preventDefault();
                let defUnit = units.find((obj) => obj.id === row.unit);
                setRowItem({ ...row, defUnit: defUnit, });
                const index = row?.no;
                const dataUpdate = [...currUnitList];
                dataUpdate[index] = {
                    ...row,
                    editUnit: true,
                };
                setCurrUnitList([...dataUpdate]);
            }
            else {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...currUnitList];
                dataUpdate[index] = {
                    ...row,
                    [props]: true,
                };
                setCurrUnitList([...dataUpdate]);
            }


        }

    };

    const MathChangIdataTtems = (prop, row) => (event) => {
        setRowItem({
            ...rowItem,
            [prop]: event.target.value,
        });
    };
    const EnterChangeTtems = (prop, rowItem, row) => {
        let i = {
            purch: Number(rowItem.purch),
            sale: Number(rowItem.sale),
            perc: Number(rowItem.perc),
        };
        let totSale = prop === "perc" ? i.perc * i.sale : i.sale;
        let totPurch = prop === "perc" ? i.perc * i.purch : i.purch;
        const index = row?.no;
        const dataUpdate = [...currUnitList];
        dataUpdate[index] = {
            ...rowItem,
            purch: totPurch,
            sale: totSale,
            perc: i.perc,
            editPerc: false,
            editUnit: false,
            editSale: false,
            editPurch: false,
            editBarcode: false,
        };
        setCurrUnitList([...dataUpdate]);
        setRowItem({});

    };


    const changeAutoUnits = (row, newValue) => {
        var newDataUnit = currUnitList.filter((obj) => obj.unit === newValue.id);

        if (newValue.id == items.unit) {
            alert("الوحدة موجودة مسبقا  كوحدة افتراضية للصنف...برجاء اختيار وحدة اخرى");
        } else if (newDataUnit.length != 0) {
            alert("الوحدة موجودة مسبقا  كوحدة فرعية ...برجاء اختيار وحدة اخرى");

        } else {
            const index = row?.no;
            const dataUpdate = [...currUnitList];
            dataUpdate[index] = {
                ...row,
                unit: newValue.id,
                unitName: newValue.name,
                editPerc: false,
                editUnit: false,
                editSale: false,
                editPurch: false,
                editBarcode: false,

            };
            setCurrUnitList([...dataUpdate]);
            setRowItem({});
        }

    };

    const onRowDelete = async (rowdata) => {
        var newData = currUnitList.filter((obj) => obj.unit !== rowdata.unit);
        const newItems = newData.map((row, i) => {
            return {
                ...row,
                no: i,
            };
        });
        setCurrUnitList([...newItems]);
        setConfirmDialog(false);
    }
    // useEffect(() => {
    // }, [currUnitList]);
    const claslbls = useStylesLbl();

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer component={Paper} style={{   minHeight: 85 }}>
            <Table
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#f18584",
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >

                        <TableCell style={stylH} align="center">
                            {t('forms:unit')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("packaging")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t('forms:purch-price')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t('forms:sale-price')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t('forms:barcode')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("print")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("delete")}
                        </TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {currUnitList.map((row) => (
                        <TableRow key={row.no}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editUnit", event, row)}
                            >
                                {
                                    row?.editUnit ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasAo}
                                            value={rowItem.defUnit}
                                            onChange={(event, newValue) => {
                                                changeAutoUnits(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={units}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            // onBlur={(e) => EnterChangeTtems("val1", rowItem, row)}
                                            disableClearable
                                            style={{ backgroundColor: colors.red[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={""}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbls.clrBlackLblS }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row.unitName
                                        )

                                }
                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editPerc", event, row)}
                            >
                                {
                                    row.editPerc ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="perc"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.red[50] }}
                                                    type="number"
                                                    name="perc"
                                                    onBlur={(e) => EnterChangeTtems("perc", rowItem, row)}
                                                    value={rowItem.perc}
                                                    onChange={MathChangIdataTtems("perc", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("perc", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("perc", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.perc)?.toFixed(2)
                                        )}
                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editPurch", event, row)}
                            >
                                {
                                    row.editPurch ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="purch"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.red[50] }}
                                                    type="number"
                                                    name="purch"
                                                    onBlur={(e) => EnterChangeTtems("purch", rowItem, row)}
                                                    value={rowItem.purch}
                                                    onChange={MathChangIdataTtems("purch", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("purch", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("purch", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row?.purch)?.toFixed(2)
                                        )}
                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editSale", event, row)}
                            >
                                {
                                    row.editSale ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="sale"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.red[50] }}
                                                    type="number"
                                                    name="sale"
                                                    onBlur={(e) => EnterChangeTtems("sale", rowItem, row)}
                                                    value={rowItem.sale}
                                                    onChange={MathChangIdataTtems("sale", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("sale", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("sale", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.sale)?.toFixed(2)
                                        )}
                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editBarcode", event, row)}
                            >
                                {
                                    row.editBarcode ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="barcode"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.red[50] }}
                                                    type="text"
                                                    name="barcode"
                                                    onBlur={(e) => EnterChangeTtems("barcode", rowItem, row)}
                                                    value={rowItem.barcode}
                                                    onChange={MathChangIdataTtems("barcode", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("barcode", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("barcode", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            row.barcode
                                        )}
                            </TableCell>

                            <TableCell align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    onClick={(event) => openPrint(row)}
                                    >
                                    <Print size={"small"} />
                                </IconButton>
                            </TableCell>
                            <TableCell align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    onClick={() => {
                                        setConfirmDialog({
                                            isOpen: true,
                                            onConfirm: () => {
                                                onRowDelete(row);
                                            },
                                        })
                                    }}>

                                    <DeleteIcon size={"small"} />
                                </IconButton>
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
